import { Component } from "@angular/core";
import { SvgIconComponent } from "../../svg-icon/svg-icon.component";
import { TosTableComponent } from "../../tos-table/tos-table.component";
import { TableMenuOption, TableMeta } from "../../../models/table-meta.interface";
import CreditNoteListingConfig from "./config/CreditNoteListingTable.config.json";
import { TableListRequest } from "../../../models/table-list-request.interface";
import { PaginatedListDataResponse } from "../../../models/paginated-list-data-response";
import { TosTableService } from "../../../services/tos-table.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FinanceApiService } from "../../../services/finance-a-p-iervice.service";
import { LoadingService } from "../../../services/loading.service";
import { ToasterService } from "../../../services/toaster.service";
import { SharedModule } from "../../../modules/shared/shared.module";
import { RequiresPermissionDirective } from "../../../directives/evaluate-permission.directive";
import { PermissionConstants } from "../../../constants/permission-constants";

@Component({
  selector: "app-credit-note",
  standalone: true,
  imports: [
    SvgIconComponent,
    TosTableComponent,
    SharedModule,
    RequiresPermissionDirective
  ],
  templateUrl: "./credit-note.component.html",
  styleUrl: "./credit-note.component.scss"
})
export class CreditNoteComponent {
  tableMeta: TableMeta = CreditNoteListingConfig.listingTableConfig;
  menuOptions: TableMenuOption[] = [
    { label: "View", value: "view",requiresPermission: {permissionIds: [PermissionConstants.CREDIT_NOTE.VIEW]} }
  ];
  rowsPerPage: number = 10;
  currentPage: number = 0;
  tableListRequest: TableListRequest = {
    limit: this.rowsPerPage,
    page: this.currentPage
  };
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: []
  };
  selectedItems: any[] = [];
  searchTerm: string = "";
  focusSearch: boolean = false;
  allTableRecordsSelected: boolean =false;

  protected readonly CreditNoteListingConfig = CreditNoteListingConfig;

  constructor(private tosTableService: TosTableService,
              private route: ActivatedRoute,
              private router: Router,
              private financeApiService: FinanceApiService,
              private loadingService: LoadingService,
              private toasterService: ToasterService) {
  }

  ngOnInit() {
    this.getTableList()
  }

  addNewCreditNote() {
    this.router.navigate(["add-new"], {relativeTo: this.route});
  }


  getTableList() {
    this.loadingService.show('inline')
    this.financeApiService.listCreditNotes(this.tableListRequest).subscribe({
      next: (res: any) => {
        console.log(res);
        this.tableListData = res.data
        this.loadingService.hide()
      },
      error: (err) => {
        console.error(err);
        this.loadingService.hide()
        this.toasterService.error(err.error.errorDesc);
      }
    });
  }

  handleOptionSelected(event: any) {
    console.log(event);
    if(event.actionName === "view") {
      this.router.navigate(["view", event.record?.id], {relativeTo: this.route});
    }
  }

  handleTableSearch($event: KeyboardEvent) {

  }

  bulkActionConfirmation(active: string) {
    return
  }

  protected readonly PermissionConstants = PermissionConstants;
}
